import { Navigate, RouteObject } from 'react-router-dom';
import React from 'react';
import { ROUTES } from './constants';

const PeopleFormTable = React.lazy(
  () => import('./components/PeopleFormTable')
);
const PeopleNav = React.lazy(() => import('./components/PeopleNav'));
const PersonDetailPage = React.lazy(
  () => import('./components/PersonDetailPage')
);
const PersonDetailGeneralInfoTab = React.lazy(
  () => import('./components/person-detail/PersonDetailGeneralInfoTab')
);
const PersonDetailWorkExperiencesTab = React.lazy(
  () => import('./components/person-detail/PersonDetailWorkExperiencesTab')
);
const PersonDetailEducationTab = React.lazy(
  () => import('./components/person-detail/PersonDetailEducationTab')
);
const PersonDetailBoardSeatsTab = React.lazy(
  () => import('./components/person-detail/PersonDetailBoardSeatsTab')
);
const PersonDetailExternalMappingsTab = React.lazy(
  () => import('./components/person-detail/PersonDetailExternalMappingsTab')
);

const { root, tableView, detailView, detailViewTabs } = ROUTES;

export const peopleRoutes: RouteObject = {
  path: root.path,
  children: [
    {
      path: root.uri,
      element: <Navigate to={tableView.uri} />,
    },
    {
      element: (
        <React.Suspense fallback={undefined}>
          <PeopleNav />
        </React.Suspense>
      ),
      children: [
        {
          path: tableView.path,
          element: (
            <React.Suspense fallback={undefined}>
              <PeopleFormTable />
            </React.Suspense>
          ),
        },
      ],
    },
    {
      path: detailView.path,
      element: (
        <React.Suspense fallback={undefined}>
          <PersonDetailPage />
        </React.Suspense>
      ),
      children: [
        {
          index: true,
          element: <Navigate to={detailViewTabs.generalInfo.path} replace />,
        },
        {
          path: detailViewTabs.generalInfo.path,
          element: (
            <React.Suspense fallback={undefined}>
              <PersonDetailGeneralInfoTab />
            </React.Suspense>
          ),
        },
        {
          path: detailViewTabs.workExperiences.path,
          element: (
            <React.Suspense fallback={undefined}>
              <PersonDetailWorkExperiencesTab />
            </React.Suspense>
          ),
        },
        {
          path: detailViewTabs.education.path,
          element: (
            <React.Suspense fallback={undefined}>
              <PersonDetailEducationTab />
            </React.Suspense>
          ),
        },
        {
          path: detailViewTabs.boardSeats.path,
          element: (
            <React.Suspense fallback={undefined}>
              <PersonDetailBoardSeatsTab />
            </React.Suspense>
          ),
        },
        {
          path: detailViewTabs.externalMappings.path,
          element: (
            <React.Suspense fallback={undefined}>
              <PersonDetailExternalMappingsTab />
            </React.Suspense>
          ),
        },
      ],
    },
  ],
};
